import {SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
  SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
  SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL,
   ADD_PRESCREENING_QUESTION, ADD_PRESCREENING_QUESTION_SUCCESS,ADD_PRESCREENING_QUESTION_FAIL,
   UPDATE_PRESCREENING_QUESTION, UPDATE_PRESCREENING_QUESTION_SUCCESS,UPDATE_PRESCREENING_QUESTION_FAIL,
   GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
   GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
   GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL
  } from "./actionTypes";

  //Prescreening selected question
   export const PrescreeningSelectedList = (data) => {
    return {
      type: GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
      payload: {data},
    };
  };

  export const PrescreeningSelectedListSuccess = (data) => {
    return {
      type: GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
      payload: data,
    };
  };

  export const PrescreeningSelectedListFail = (data) => {
    return {
      type: GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL,
      payload: data,
    };
  };

  
    export const getpreScreeningAssesmentList = (data) => {
      return {
        type: SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
        payload: data,
      };
    };
    export const getpreScreeningAssesmentListSuccess = (questions) => {
      return {
        type: SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
        payload: questions,
      };
    };
    export const getpreScreeningAssesmentListFailed = (error) => {
      return {
        type: SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL,
        payload: error,
      };
    };
  

  //add newPrescreening questions

    export const addNewPreScreening = (data) => {
      return {
        type: ADD_PRESCREENING_QUESTION,
        payload: {data},
      };
    };

    export const addNewPreScreeningSuccess = (data) => {
      return {
        type: ADD_PRESCREENING_QUESTION_SUCCESS,
        payload: {data},
      };
    };

    export const addNewPreScreeningFail = (data) => {
      return {
        type: ADD_PRESCREENING_QUESTION_FAIL,
        payload: {data},
      };
    };

    // update prescreening questions

    export const upDatePreScreening = (data) => {
      return {
        type: UPDATE_PRESCREENING_QUESTION,
        payload: {data},
      };
    };

    export const upDatePreScreeningSuccess = (data) => {
      return {
        type: UPDATE_PRESCREENING_QUESTION_SUCCESS,
        payload: {data},
      };
    };

    export const upDatePreScreeningFail = (data) => {
      return {
        type: UPDATE_PRESCREENING_QUESTION_FAIL,
        payload: {data},
      };
    };